/**
 * 설비 아이콘 , 템플릿의 icon 키로 고른다. 획 하나짜리 monoline, currentColor.
 * 키: drop stack filter gear compress tank snow truck pipe flame factory box
 */
const PATHS: Record<string, string> = {
  drop: "M12 3c3 4.5 6 7.5 6 11a6 6 0 0 1-12 0c0-3.5 3-6.5 6-11z",
  stack: "M6 4v16M12 4v16M18 4v16M4 8h16M4 16h16",
  filter: "M5 4h14v4l-5 5v7l-4-2v-5L5 8z",
  gear: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1 7 17M17 7l2.1-2.1",
  compress: "M4 12h6M14 12h6M8 8l-4 4 4 4M16 8l4 4-4 4M12 4v16",
  tank: "M7 4h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM5 10h14M5 14h14",
  snow: "M12 2v20M2 12h20M5 5l14 14M19 5 5 19",
  truck: "M2 7h11v9H2zM13 10h5l3 3v3h-8zM6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  pipe: "M2 9h8v6H2zM14 9h8v6h-8zM10 12h4M6 9V5M18 15v4",
  flame: "M12 3c1 4 5 5 5 10a5 5 0 0 1-10 0c0-2 1-3 2-4 0 2 1 3 2 3 0-3-1-6 1-9z",
  factory: "M3 21V10l5 3V10l5 3V10l5 3v8zM3 21h18M8 17h2M13 17h2M17 10V4h2v6",
  box: "M4 8l8-4 8 4v8l-8 4-8-4zM4 8l8 4 8-4M12 12v8",
};

export function EquipmentIcon({ icon, className = "size-icon-nav" }: { icon: string; className?: string }) {
  const d = PATHS[icon] ?? PATHS.box!;
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d={d} />
    </svg>
  );
}
